import { Duck } from '@atc/modular-redux';
import creators from './actionCreators/index.js';
import reducer from './reducer';
import selectors from './selectors';
import types from './types';
import defaultState from './defaultState';
export default function paymentsDuckCreator(_temp) {
  let {
    namespace = '',
    store = 'payments',
    storePath,
    initialState = {},
    paymentFetcher,
    walletStorageService,
    ownerDetailsFetcher,
    ...rest
  } = _temp === void 0 ? {} : _temp;
  return new Duck({
    ...rest,
    namespace,
    store,
    storePath,
    consts: {},
    types,
    initialState: {
      ...defaultState,
      ...initialState
    },
    reducer,
    selectors,
    creators: duck => creators(duck, walletStorageService, ownerDetailsFetcher)
  });
}